module.exports = __webpack_public_path__ + "static/media/IOTSU_S1_M04.0652affd.jpg";